import { Link } from "react-router-dom";
import { ExternalLink, ArrowRight } from "lucide-react";
import BookCover from "./BookCover";
import ShareButton from "./ShareButton";
import { amazonUrl, isComingSoon } from "../data/books";

export default function BookCard({ book }) {
  const comingSoon = isComingSoon(book);
  return (
    <div
      data-testid={`book-card-${book.slug}`}
      className="group relative flex flex-col h-full bg-white rounded-3xl border-2 border-black/10 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden"
    >
      <ShareButton book={book} variant="icon" className="absolute top-3 right-3 z-20" />
      <Link
        to={`/books/${book.slug}`}
        data-testid={`book-cover-link-${book.slug}`}
        className="block aspect-[3/4] overflow-hidden relative"
      >
        {comingSoon && (
          <span
            data-testid={`coming-soon-badge-${book.slug}`}
            className="absolute top-3 left-3 z-10 rounded-full bg-black text-white px-3 py-1 text-xs font-bold shadow-md"
          >
            Coming Soon
          </span>
        )}
        <div className="w-full h-full transition-transform duration-300 group-hover:scale-105">
          <BookCover book={book} />
        </div>
      </Link>

      <div className="flex flex-col flex-1 p-5">
        <span
          className="self-start rounded-full px-3 py-1 text-xs font-bold mb-3"
          style={{
            backgroundColor: book.category === "Workbooks" ? "#0000FF" : "#00EE00",
            color: book.category === "Workbooks" ? "#FFFFFF" : "#000000",
          }}
        >
          {book.category}
        </span>

        <h3 className="font-heading font-bold text-lg leading-snug text-black">
          <Link to={`/books/${book.slug}`} data-testid={`book-title-link-${book.slug}`} className="hover:underline">
            {book.shortTitle}
          </Link>
        </h3>

        <p className="text-sm text-slate-600 mt-2 flex-1">{book.tagline}</p>

        <span className="inline-block mt-3 text-xs font-bold text-slate-500">
          {book.ageRange}
        </span>

        <div className="mt-4 flex flex-col gap-2">
          {comingSoon ? (
            <>
              <span
                data-testid={`coming-soon-${book.slug}`}
                className="inline-flex items-center justify-center gap-2 min-h-[48px] rounded-full font-bold text-black bg-[#FBEF14] border-2 border-black px-5 cursor-default"
              >
                Coming Soon
              </span>
              <Link
                to="/#learning-circle"
                data-testid={`join-waitlist-${book.slug}`}
                className="inline-flex items-center justify-center gap-2 min-h-[48px] rounded-full font-bold text-white bg-[#FF0000] hover:bg-[#d60000] hover:-translate-y-0.5 transition-all duration-200 px-5"
              >
                Join the Learning Circle <ArrowRight size={16} />
              </Link>
            </>
          ) : (
            <a
              href={amazonUrl(book.amazon)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`buy-amazon-${book.slug}`}
              className="inline-flex items-center justify-center gap-2 min-h-[48px] rounded-full font-bold text-white bg-[#0000FF] hover:bg-[#0000d6] hover:-translate-y-0.5 transition-all duration-200 px-5"
            >
              Buy on Amazon <ExternalLink size={18} />
            </a>
          )}
          <Link
            to={`/books/${book.slug}`}
            data-testid={`book-details-${book.slug}`}
            className="inline-flex items-center justify-center gap-1 text-sm font-bold text-[#0000FF] hover:gap-2 transition-all duration-200"
          >
            View details <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
}
